//
// Generated class ProductionNote
//

/// <reference path="ProductionNote_ManagedObject.ts" />

class ProductionNote extends ProductionNote_ManagedObject
{

}
